<div class="row">
    <div class="col-12">
        <div class="card">
            <app-list-layout [tableConfig]="tableConfig" [listItems]="listItems"
                [listService]="emailsListService" (buttonActionSelected)="buttonActionSelected($event)"
                (updateCheckedValues)="checkedValGet =  $event" (rowActionSelected)="rowActionSelected($event)"
                (filterSelected)="filterSelected($event)" (sortSelected)="sortByPassedSort($event)"
                (searchTermChanged)="emailsListService.searchTerm = $event"
                (resetListLayout) = "emailsListService.resetListState($event)"
                (paginationSelected)="paginationUpdated(emailsListService,$event)" [serviceData]="serviceData"
                (pageSizeSelected)="emailsListService.pageSize = $event"></app-list-layout>
        </div>
    </div>
</div>